import { IBaseModel } from '../base/base.model';
import { CatchHubLogType } from './catchHubLog.enum';

/**
 * Server-side filter criteria for the admin Logs screen. Every field is optional; an
 * omitted/empty value means "don't filter on this". `fromDate` / `toDate` are ISO-8601 UTC
 * instants produced from the locally-entered picker value, compared against `createdDate`.
 */
export interface ICatchHubLogFilter {
  searchDescription?: string;
  fromDate?: string;
  toDate?: string;
  logType?: CatchHubLogType;
  eventType?: string;
  userName?: string;
}

export interface ICatchHubLogModel extends IBaseModel {
  nextGenProjectName: string;
  nextGenProjectId: string;
  eventType: string;
  nodeKey: string;
  externalItemId: string;
  logType: string;
  userName: string;
}

export class CatchHubLogModel implements ICatchHubLogModel {
  constructor(
    public id: string,
    public description: string,
    public createdDate: string,
    public modifiedDate: string,
    public createdBy: string,
    public modifiedBy: string,
    public nextGenProjectName: string,
    public nextGenProjectId: string,
    public eventType: string,
    public nodeKey: string,
    public externalItemId: string,
    public logType: string,
    public userName: string,
  ) {}
}
